const afterApprovalStatuses = [
  'Approved',
  'Approved For Future',
  'Ready For Fulfillment',
  'On Hold',
  'Picked',
  'Dispensed',
  'Packed'
]

const afterRejectionStatuses = ['Rejected', 'Refunded']

// Mirrors NodeAPI's APPROVED_STATUSES: the stages whose justification is an approval reason.
// Unlike afterApprovalStatuses, it leaves out On Hold and includes Pharmacist Check.
const approvedStatuses = [
  'Approved',
  'Approved For Future',
  'Ready For Fulfillment',
  'Pharmacist Check',
  'Picked',
  'Dispensed',
  'Packed'
]

// 'System FAN Check' is where a V2 hold waits for the patient's answers.
const onHoldStatuses = ['On Hold', 'Clinical Further Answers Needed', 'Clinical Query', 'System FAN Check']

/**
 * Cap on treatments per MPS (MultiProduct Subscription) order: Treatment 1 plus the extra cards.
 * Check it via `isMpsTreatmentLimitReached` (lib/utils) rather than comparing against this directly.
 */
const MPS_MAX_TREATMENTS = 3

/**
 * The product category an MPS treatment must belong to. On an MPS order the treatment picker
 * lists only catalogue rows carrying this category (`isMpsCategoryMedication`, lib/utils).
 */
const MPS_CATEGORY_HASH = '70227f22d38dc3b4e7ac361fb4a9ea'

export {
  afterApprovalStatuses,
  afterRejectionStatuses,
  approvedStatuses,
  MPS_CATEGORY_HASH,
  MPS_MAX_TREATMENTS,
  onHoldStatuses
}
